<template>
  <div class="dropdown-selection w-150px mr-5">
    <div class="dropdown-selection-head" @click="isModalShow = !isModalShow">
      <button class="btn" style="width: 100%;" @blur="closeMenu">
        <span class="mr-3" :class="{ 'ink-01-emphasis--text': isModalShow }"
          >{{ placeholder }}</span
        >
        <span v-if="isModalShow">
          <v-icon>arrow_drop_up</v-icon>
        </span>
        <span v-if="!isModalShow">
          <v-icon>arrow_drop_down</v-icon>
        </span>
      </button>
    </div>
    <div class="dropdown-selection-body block w-260px" v-if="isModalShow">
      <v-radio-group v-model="stateOfBUPageFilterShowed">
        <div
          class="pl-10px h-48px d-flex align-center selection-item-hover"
          v-for="(item, i) in [
            { label: '不限' },
            { label: '顯示' },
            { label: '隱藏' },
          ]"
          :key="item.label"
          @click="changeShowState"
        >
          <v-radio :value="i" color="brand-600" class="flex-grow-1">
            <template v-slot:label>
              <div class="h5 ink-01-emphasis--text h-48px d-flex align-center">
                {{ item.label }}
              </div>
            </template>
          </v-radio>
        </div>
      </v-radio-group>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: [Number, String],
      default: '0',
    },
  },
  data: () => ({
    status: {
      0: '',
      1: 1,
      2: 0,
    },
    statusText: {
      0: '篩選顯示/隱藏',
      1: '顯示',
      2: '隱藏',
    },
    isModalShow: false,
    stateOfBUPageFilterShowed: 0, // value from zero: '不限'
  }),
  computed: {
    placeholder() {
      return this.statusText[this.stateOfBUPageFilterShowed];
    },
  },
  methods: {
    changeShowState() {
      this.$emit('input', this.status[this.stateOfBUPageFilterShowed]);
      this.isModalShow = false;
    },
    closeMenu() {
      setTimeout(() => {
        this.isModalShow = false;
      }, 300);
    },
  },
};
</script>

<style></style>
